module.exports = __webpack_public_path__ + "img/KV.10d23d2e.png";